import waitForDependency from 'lib/waitForDependency';

import standardCoreAdapter from './standardCoreAdapter';
import golfCoreAdapter from './golfCoreAdapter';
import foodcomSiteAdapter from './foodcomSiteAdapter';

const adapters = {
  golfdigest: golfCoreAdapter,
  foodcom: foodcomSiteAdapter,
  '*': standardCoreAdapter,
};

/**
 * Looks for mdManager and determines which adapter to use, based on the site
 */
export default function mdManagerAdapter() {
  return waitForDependency(() =>
    (window.mdManager && (window.mdManager.getSite().length > 0) ? window.mdManager : undefined))
    .then((mdManager) => {
      const site = mdManager.getSite();

      /* eslint-disable-next-line no-restricted-syntax */
      for (const key in adapters) {
        if ((key === site.toLowerCase() || key === '*') && adapters[key]) return adapters[key];
      }

      throw new Error('MCPxxx: No configured adapter for this site');
    })
    .catch(() => { throw new Error('MCPxxx: mdManager not found'); });
}
